import { useEffect, useState } from 'react';
import { Card } from '../../../../../components/card/card';
import { DistinctSelect } from '../../../../../components/distinct-select/distinct-select';
import { Field } from '../../../../../components/field/field';
import { Typography } from '../../../../../components/typography/typography';

export const RentalLimit = ({
  rentalLimit,
  setRentalLimit,
  save,
  isSaving,
}: {
  rentalLimit: number | undefined;
  setRentalLimit: (rentalLimit: number | undefined) => void;
  save: (values?: { rentalLimit?: number | null }) => void;
  isSaving: boolean;
}) => {
  const [localValue, setLocalValue] = useState<string>(rentalLimit?.toString() || '');

  useEffect(() => {
    setLocalValue(rentalLimit?.toString() || '');
  }, [rentalLimit]);

  const options = [
    {
      label: 'No limit',
      value: <Typography type="text-sm">No limit</Typography>,
      isSelected: rentalLimit === undefined,
    },
    {
      label: 'Limit',
      value: <Typography type="text-sm">Set maximum number of active rentals </Typography>,
      isSelected: rentalLimit !== undefined,
    },
  ];

  return (
    <Card className="card flex flex-col gap-4">
      <div>
        <Typography type="text-xl" weight="semi-bold">
          Rental Limit
        </Typography>
        <Typography type="text-md" weight="regular" className="text-grey-500">
          Control how many products a customer can have rented at the same time with this discount.{' '}
        </Typography>
      </div>
      <DistinctSelect
        options={options}
        onChange={(selected) => {
          const rentalLimit = selected.label === 'No limit' ? undefined : 1;
          setRentalLimit(rentalLimit);
          setLocalValue(selected.label === 'No limit' ? '' : '1');
          save({ rentalLimit: selected.label === 'No limit' ? null : 1 });
        }}
      />

      <Field
        label="Quantity"
        isRequired
        type="number"
        value={localValue}
        disabled={rentalLimit === undefined || isSaving}
        onChange={(value: string) => setLocalValue(value)}
        dataCy="product_quantity"
        onBlur={(e) => {
          const value = e.target.value;
          if (value === '' || value === '0') {
            setRentalLimit(undefined);
            save({ rentalLimit: null }); // Clear the limit
          } else {
            const numValue = parseInt(value, 10);
            setRentalLimit(numValue);
            save({ rentalLimit: numValue });
          }
        }}
      />
    </Card>
  );
};
